// extracted by mini-css-extract-plugin
module.exports = {"container":"pagination_container__17RhO","item":"pagination_item__19AtT","active":"pagination_active__3KJ2K","dark":"pagination_dark__2bkIL"};